<template>
  <div>
    <v-menu
      offset-y
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          text
          :color="other.b_color || 'primary'"
          v-bind="attrs"
          v-on="on"
        >
          {{ other.b_text }}
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="(btn,index) in btns"
          :key="index"
          link
          @click="click(btn)"
        >
          <v-list-item-content>
            <v-list-item-title>
              <div :style="`font-size:${btn.fontSize}`">
                {{ btn.text }}
              </div>
              <!-- <v-btn
                text
                :small="btn.small || other.small"
                :x-small="btn['x-small'] || other['x-small']"
                @click="click(btn)"
              >
                {{ btn.text }}
              </v-btn> -->
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
  export default {
    props: {
      btns: {
        type: Array || Function,
        default:() => [] 
      },
      other: {
        type: Object,
        default: () => ({})
      },
      target: {
        type: Object,
        default: () => ({}) 
      }
    },
    computed:{
      btns_proxy() {
        console.log('target', this.target)
        if (this.btns instanceof Function) {
          return this.btns(this.target)
        } else {
          return this.btns
        }
      }
    },
    methods: {
      click(btn) {
        this.other.callBack && this.other.callBack(btn, this.target)
      }
    }
  }
</script>